// extracted by mini-css-extract-plugin
export default {"wrapper":"NumberOfAttempts_wrapper__rJ8UL","title":"NumberOfAttempts_title__y4FDf","input":"NumberOfAttempts_input__VWo7i"};